import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

/** @deprecated use cn from `@gymflow/helpers` instead */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
